import _ from "lodash";
import { useCallback } from 'react';

import { LangChooserButton } from '../lang-chooser-button/LangChooserButton';
import { LangInfo } from '../lang-info/LangInfo';
import { Slider } from "../../../../components/Slider/Slider";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext.js";
import { DropdownItemStyled } from "../../../../components/Dropdown/styled/DropdownStyled.js";

export const LangChooserSlider = ({
    isHideButtonName,
    isHideButtonArrowIcon,
    locales,
    onSelectLang,
    toggleButtonComponent
}) => {
    const {lang} = useLangContext();

    const handleLangRowClick = useCallback((event) => {
        const value = _.get(event, ['currentTarget', 'dataset', 'value']);
        if (value) {
            onSelectLang(value);
        }
    }, [onSelectLang]);

    const ToggleComponent = toggleButtonComponent || LangChooserButton;

    return <Slider
        toggleComponent={<ToggleComponent isHideName={isHideButtonName} isHideArrowIcon={isHideButtonArrowIcon}/>}
        headerContentComponent={<LangInfo iconName={lang.lang} langName={lang.langName}/>}
    >
        {locales.map(({value, fullName}) => (
            <Slider.Row key={value} data-value={value} onClick={handleLangRowClick}>
                <DropdownItemStyled>
                    <LangInfo iconName={value} langName={fullName}/>
                </DropdownItemStyled>
            </Slider.Row>
        ))}
    </Slider>
};